import { gql } from '@apollo/client';

/**
 * 揽收站点 2.0 草稿预占（站点ID预取）：
 * - createDraftCooperationWarehouse(hubId, sourceKey) 插 DRAFT 占位返回真实 cw.id，供建群/展示；随后 saveCooperationWarehouse 转正。
 *   sourceKey 相同且未转正的草稿会复用同一 id —— 运营在保存前就拿该 id 去建微信群（群名含站点ID），
 *   取消后重进若换新 id 会导致群名与最终站点 ID 永久错位。故关闭抽屉时不再删草稿，超 24h 未转正由清理任务回收。
 * - deleteDraftCooperationWarehouse(id) 显式丢弃草稿（仅删 status=DRAFT）；常规关闭不再调用。
 */
export const CREATE_DRAFT_COOPERATION_WAREHOUSE = gql`
  mutation CreateDraftCooperationWarehouse($hubId: Long!, $sourceKey: String) {
    createDraftCooperationWarehouse(hubId: $hubId, sourceKey: $sourceKey)
  }
`;

export interface CreateDraftCooperationWarehouseResponse {
  createDraftCooperationWarehouse: number;
}

export const DELETE_DRAFT_COOPERATION_WAREHOUSE = gql`
  mutation DeleteDraftCooperationWarehouse($id: Long!) {
    deleteDraftCooperationWarehouse(id: $id)
  }
`;

export interface DeleteDraftCooperationWarehouseResponse {
  deleteDraftCooperationWarehouse: boolean;
}
